<template>
  <div class="about-us-page ignore-mobile-page">
    <div class="ignore-content-wrapper">
      <div class="title">简介</div>
      <p>功夫好车始创于2016年，总部位于北京，是一家集“汽车供应链、汽车服务”为一体的全场景、全覆盖的汽车新零售服务提供商，为用户提供轻松、低价、高品质的一站式购车服务，让好车得来全不费功夫！</p>
      <div class="title">业务模式</div>
      <p>依托强大的资金实力、高效IT研发能力和数据运用能力，通过“汽车超市+社区体验店”相结合，重构了“人、车、店”的关系。并针对用户多样化的需求，通过完整的汽车供应链和融资租赁产品创新，为用户提供“低首付、低门槛”的智慧化购车体验。</p>
      <div class="title">城市分布</div>
      <p>目前业务覆盖北京、银川、大连、沈阳、郑州、唐山、承德等7个城市。2018年将在全国新增100个城市，未来三年将扩充至300个全国主要城市。</p>
      <div class="title">理念</div>
      <p>功夫好车始终坚持“相信口碑的力量”，坚持为用户提供“低首付、低门槛”的多品牌汽车购买服务，以“让每个用户都能买好车”为使命，不断为用户创造更好的服务。</p>
    </div>
    <car-footer></car-footer>
  </div>
</template>

<script>
import carFooter from '../../../components/mobile/footer';

export default {
  components: { carFooter }
};
</script>

<style lang="scss" scoped>
@import "../../../styles/mixin.scss";

.about-us-page {
  background-color: #ffffff;
  .ignore-content-wrapper {
    font-size: 14px;
    line-height: 16px;
    padding-bottom: 50px;
    padding-left: 15px;
    padding-right: 15px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;

    .title {
      color: #F0DC28;
      font-size: 16px;
      margin-bottom: 15px;
      margin-top: 20px;
      font-family: "PingFangSC-Semibold";
      width: 104px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      z-index: 1;
      position: relative;

      &::after {
        @include skew-bg;
        background-color: #000;
      }
    }

    p {
      font-size: 12px;
      font-family: "PingFangSC-Regular";
      margin: 0;
    }
  }
}
</style>
